export default {
  language: "Language",
  spanish: "Español",
  english: "English",
  back: "Back",
  backHome: "Back to Home",
  backToHome: "Back to home",
  save: "Save",
  saving: "Saving…",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  search: "Search",
  loading: "Loading...",
  error: "Error",
  success: "Success",
  understood: "Got it",
  close: "Close",
  settings: "Settings",
  profile: "Profile",
  myAccount: "My account",
  admin: "Admin",
  logout: "Log out",
  yes: "Yes",
  no: "No",
  confirm: "Confirm",
  required: "Required",
  optional: "Optional",
  noResults: "No results found",
  imageUnavailable: "Image unavailable",
  allRightsReserved: "All rights reserved.",
  restrictedAccess: "Restricted Access",
  importantInfo: "Important Information",
  selectDate: "Select Date",
  private: "Private",
  insurance: "Insurance",
  demo: "Demo - Quick Access",
};
